const swea = require('swea');
import React from 'react';
import { BrowserRouter, Route, Switch} from 'react-router-dom';
import Index from './Index.jsx';
const ContextProvider = swea.react.components.app.ContextProvider;

/***
 * Define all application routes and provide the application root context.
 */
const context = {
  /**
   *  Create the insertCss function to dynamically insert css.
   *  @ignore
   */
  insertCss: styles => styles._insertCss()
};

const Routes = (
  <ContextProvider
    context={context}
    annotationBox={true}
    imageViewer={true}
    imageCatalogue={true}
    modelCatalogue={true}
    bimObjectCatalogue={false}
    instruction={swea.util.getQueryParameters().noinstruct !== '1'}
    dialog={true}
  >
    <BrowserRouter>
        <Switch>
          <Route path="/" component={Index} />
        </Switch>
    </BrowserRouter>
  </ContextProvider>
);

export default Routes;
